import * as React from "react";

function SvgPocketSquares(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#pocket-squares_svg__clip0)">
        <path d="M17.69 10.466l1.045 1.045-7.225 7.224-1.045-1.045 7.225-7.224zm-15.403 0l-1.034 1.033 7.225 7.225 1.034-1.034-7.225-7.225zm7.225-8.178L8.49 1.265 1.265 8.49l1.022 1.023 7.225-7.225zM2.763 9.989l7.225 7.225 7.225-7.225-7.225-7.225L2.763 9.99zm17.063-.407l-.627-.627-1.033 1.034 1.044 1.045.616-.616a.591.591 0 000-.836zm-2.137-.07l1.034-1.033-7.225-7.225-1.033 1.034 7.224 7.225zM.788 8.968l-.615.615a.591.591 0 000 .836l.604.605 1.034-1.034L.788 8.967zM8.954 19.2l.627.627a.59.59 0 00.836 0l.616-.616-1.045-1.045L8.954 19.2zM11.022.778l-.605-.604a.591.591 0 00-.836 0l-.615.615L9.988 1.81 11.022.778z" />
      </g>
    </svg>
  );
}

export default SvgPocketSquares;
